import { findAll } from '@/api/domains.api'
import decoder from '@/decoders/domains'
import useAPI from '../useAPI'

export default (params = {}) => useAPI({
  request: findAll,
  params,
  decoder
})
